import { render, staticRenderFns } from "./VerticalBrandTile.vue?vue&type=template&id=5779c7cc&scoped=true&"
import script from "./VerticalBrandTile.vue?vue&type=script&lang=ts&"
export * from "./VerticalBrandTile.vue?vue&type=script&lang=ts&"
import style0 from "./VerticalBrandTile.vue?vue&type=style&index=0&id=5779c7cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5779c7cc",
  null
  
)

export default component.exports